import React, { useContext, useEffect } from 'react';
import { Redirect, useParams } from 'react-router';

import { Container, Gap } from 'components';
import { AuthContext, isOrgFeatureEnabled, useSpot } from 'framework';

import { Expenses } from './user-info/expenses';

export function ExpensesPage() {
  const { organization } = useParams<{ organization: string }>();
  const { getCurrentUser } = useContext(AuthContext);
  const { data, query } = useSpot();
  const id = getCurrentUser();
  const org = data?.organizations?.[organization];

  useEffect(() => {
    if (!org) {
      query(`org/${organization}`, {}, ['organizations', organization]);
    }
  }, [org, organization, query]);

  if (!org) {
    return <></>;
  }

  if (!isOrgFeatureEnabled(org, 'expenses')) {
    return <Redirect to={`/${organization}`} />;
  }

  return (
    <Container>
      <Expenses id={id} organization={organization} />
      <Gap />
    </Container>
  );
}
